export const initialState = () => ({
  contract: {
    additives: [],
    discount_type: "",
    discount: "",
    contract_type: "",
    shipping: "",
    shippingName: "",
    dueDate: "",
    payment: "",
    bank: "",
    agency: "",
    account: ""
  }
})
